import { render, staticRenderFns } from "./PrivacyDoc.vue?vue&type=template&id=271596ca&scoped=true"
import script from "./PrivacyDoc.vue?vue&type=script&lang=js"
export * from "./PrivacyDoc.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDoc.vue?vue&type=style&index=0&id=271596ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271596ca",
  null
  
)

export default component.exports